export default {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  API_PREFIX: process.env.REACT_APP_API_PREFIX,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  IS_PRODUCTION: process.env.REACT_APP_BUILD === 'Production',
  IS_STAGING: process.env.REACT_APP_BUILD === 'Staging',
  IS_DEV: process.env.REACT_APP_BUILD === 'Development',
  BUILD_ENV: process.env.NODE_ENV,
  CURRENT_BUILD: process.env.REACT_APP_BUILD,
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  AUTH0_CLIENT: process.env.REACT_APP_AUTH0_CLIENT_ID,
  REDIRECT_LOGOUT_URL: process.env.REACT_APP_AUTH0_REDIRECT_URL,
  ELEVEIO_ACCOUNT_ID: process.env.REACT_APP_ELEVIO_ACCOUNT_ID,
  FEATURE_FLAGS: {
    IS_MODEL_PORTFOLIO_CREATOR:
      process.env.REACT_APP_FEATURE_MODEL_PORTFOLIO_CREATOR === 'true'
  },
  IO_CLIENT: process.env.REACT_APP_CLIENT_IO,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  POSTHOG_KEY: process.env.REACT_APP_POSTHOG_KEY,
  POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST
};
